// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"b05b22f1","805":"29195035","823":"e46e51a7","884":"1092dadb","911":"5c986a00"}[chunkId] + ".chunk.js";
};